import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { strings } from "../../../localization";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { closeModal } from "../reducers";

type Props = Immutable<{
    isRefreshing: boolean;
    firstName: string;
}>;

export const BodyContent = (props: Props): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const purchasePrice = useAppSelector(
        (state) => state.financing.purchasePrice,
    );
    const buttonText =
        (purchasePrice
            ? strings.get("FINANCING_RETURN_TO_CHECKOUT")
            : strings.get("FINANCING_RETURN_TO_SITE")) || "";

    if (props.isRefreshing) {
        return (
            <p>
                {t`This may take a couple minutes. Please do not navigate away
                    from this screen until you see a credit decision page.`}
            </p>
        );
    }
    const cardName = strings.get("FINANCING_CARD_NAME");
    return (
        <>
            <p>
                {richT(
                    t`Thank you, ${props.firstName}, for your interest in the ${cardName}!`,
                )}
            </p>
            <p>{strings.get("FINANCING_APP_PENDING_MSG")}</p>
            <button
                className="button"
                onClick={(e) => {
                    e.preventDefault();
                    dispatch(closeModal());
                }}
            >
                {buttonText}
            </button>
        </>
    );
};
